<template>
  <div :class="tableClass">
    <table class="full-width">
      <tr>
        <th rowspan="2">
          <div class="full-width" :style="{ position: 'relative' }">
            <img
              v-if="image"
              class="table-section-icon"
              :src="image"
              :style="{
                position: 'absolute',
                right: '0px',
                bottom: '-8px',
              }"
            />
          </div>
        </th>
        <th
          :colspan="tableData.headers.length"
          class="primary-background h4 color-white text-center my-0 py-0"
          :class="headerClass"
          :style="{
            lineHeight: '8px',
          }"
        >
          {{ $t(`PRODUCT_${tableId}`) }}
        </th>
      </tr>
      <tr>
        <td
          v-for="(header, i) in tableData.headers"
          :class="`body-1--bold ${tableTextclass} text-center`"
          :key="'header-' + i"
        >
          {{ $t(header) }}
        </td>
      </tr>
      <tr v-for="(kgKey, i) in Object.keys(tableData.kgRows)" :key="'row-' + i">
        <td :class="`text-center ${tableTextclass} body-1--bold`">
          {{ kgKey }}<span class="body-1--bold"> Kg</span>
        </td>
        <td
          :class="`text-center ${tableTextclass} `"
          v-for="(value, i) in tableData.kgRows[kgKey]"
          :key="'price-col-' + i"
        >
          {{ value }}<span class="euro-symbol">€</span>
        </td>
      </tr>
      <tr v-if="hasAdditionalKgPrices" class="grey-background">
        <td :class="`body-1--bold text-center grey-background pb-1 ${tableTextclass}`">
          {{ $t('ADD_KILO') }}
        </td>
        <td
          v-for="(value, i) in tableData.addKilo"
          :key="'additKg-' + i"
          :class="`text-center grey-background pb-1 ${tableTextclass}`"
        >
          {{ value }} <span class="euro-symbol">€</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PdfProductTable',
  props: ['type', 'tableData', 'tableId', 'image'],
  computed: {
    headerClass() {
      if (this.isPeninsular) {
        return 'h4--6'
      }
      if (this.isCanary || this.isBalear || this.isOtherDestinations) {
        return 'h4--5 pb-1'
      }
      return 'h4'
    },
    isBalear() {
      return this.type === 'balear'
    },
    isCanary() {
      return this.type === 'cannary'
    },
    isPeninsular() {
      return this.type === 'peninsular'
    },
    isOtherDestinations() {
      return this.type === 'otherDestinations'
    },
    tableClass() {
      let classes = ''
      if (this.isPeninsular) {
        classes = 'table-section'
      } else if (this.isCanary || this.isBalear) {
        classes = 'table-section-single'
      } else if (this.isOtherDestinations) {
        classes = 'table-section-other-destintations'
      } else if (this.type === 'economy') {
        classes = 'table-section-international-economy'
      } else {
        classes = 'table-section-international'
      }
      return classes
    },
    tableTextclass() {
      return this.type === 'international' || this.type === 'economy' || this.type === 'ecommerce'
        ? 'body-2'
        : 'body-1'
    },
    hasAdditionalKgPrices() {
      return this.tableData?.addKilo?.length > 0
    },
  },
}
</script>
